function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobioplusLogo = function SvgMobioplusLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 418 137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M293.935 132.659v-12l5.538 5.538.234.228 5.766-5.766v10.614h-2.766v-3.69l-3 3-3-3v3.69l-2.772 1.386Z",
    style: {
      fill: "url(#mobioplus_logo_svg__a)",
      fillRule: "nonzero"
    },
    transform: "translate(-2140.803 -829.685) scale(7.28325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.543 128.501a.23.23 0 0 0 .234-.228v-3.228a.23.23 0 0 0-.234-.234h-4.152a.23.23 0 0 0-.228.234v3.228c0 .126.102.228.228.228h4.152Zm-4.842 2.772-.924-.462-.924-.924-.462-.924v-4.614l.462-.924.924-.924.924-.456h5.538l.924.456.918.924.462.924v4.614l-.462.924-.918.924-.924.462h-5.538Z",
    style: {
      fill: "url(#mobioplus_logo_svg__b)",
      fillRule: "nonzero"
    },
    transform: "translate(-2140.803 -829.685) scale(7.28325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.619 128.501a.23.23 0 0 0 .234-.228.23.23 0 0 0-.234-.228h-4.38v.456h4.38Zm-7.152 2.772v-6h7.152a.23.23 0 0 0 .234-.228.23.23 0 0 0-.234-.234h-5.766l-1.386-2.766h7.848l.924.456.918.924.462.924v1.386l-.462.924.462.924v1.38l-.462.924-.918.924-.924.462h-7.848Z",
    style: {
      fill: "url(#mobioplus_logo_svg__c)",
      fillRule: "nonzero"
    },
    transform: "translate(-2140.803 -829.685) scale(7.28325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.543 132.659v-10.614h2.772v9.228l-2.772 1.386Z",
    style: {
      fill: "url(#mobioplus_logo_svg__d)",
      fillRule: "nonzero"
    },
    transform: "translate(-2140.803 -829.685) scale(7.28325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.385 128.501a.23.23 0 0 0 .234-.228v-3.228a.23.23 0 0 0-.234-.234h-4.152a.23.23 0 0 0-.228.234v3.228c0 .126.102.228.228.228h4.152Zm-4.842 2.772-.924-.462-.924-.924-.462-.924v-4.614l.462-.924.924-.924.924-.456h5.538l.924.456.918.924.462.924v4.614l-.462.924-.918.924-.924.462h-5.538Z",
    style: {
      fill: "url(#mobioplus_logo_svg__e)",
      fillRule: "nonzero"
    },
    transform: "translate(-2140.803 -829.685) scale(7.28325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.999 131.273v-3.228h-3.69v-2.772h3.69v-3.228h2.772v3.228h3.69v2.772h-3.69v3.228h-2.772Z",
    style: {
      fill: "url(#mobioplus_logo_svg__f)",
      fillRule: "nonzero"
    },
    transform: "translate(-2156.61 -888.885) scale(7.28325)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobioplus_logo_svg__a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-17.788 569.345 -873.382) scale(59.6789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f100a6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobioplus_logo_svg__b",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-17.788 569.345 -873.382) scale(59.6789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f100a6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobioplus_logo_svg__c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-17.788 569.345 -873.382) scale(59.6789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f100a6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobioplus_logo_svg__d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-17.788 569.345 -873.382) scale(59.6789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f100a6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobioplus_logo_svg__e",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-17.788 569.345 -873.382) scale(59.6789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f100a6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobioplus_logo_svg__f",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-17.788 596.399 -876.251) scale(59.6789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f100a6",
      stopOpacity: 1
    }
  }))));
};
export { SvgMobioplusLogo as ReactComponent };
export default "data:image/svg+xml;base64,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";